import { Loader } from "@googlemaps/js-api-loader";
import stylesArray from "./map-styles";
import { isMobile } from "./helper";

class handleGoogleMaps {
  constructor() {
    this.loader = new Loader({
      apiKey: "AIzaSyC02vIz4qrp5yAoHWeMX-tQ9GBbkgirI9Y"
    });
    this.map = null;
    this.defaultIcon =
      "http://kamienicepoznanskie.pl/wp-content/uploads/2020/10/logo.svg";
    this.selectedMarker = null;

    this.loadMap();
  }

  loadMap() {
    let centerCoords = { lat: 52.4061, lng: 16.9238 };
    let zoom = 13;

    if (isMobile()) {
      centerCoords = { lat: 52.0914, lng: 17.2206 };
      zoom = 5.5;
    }

    this.loader.load().then(() => {
      this.map = new google.maps.Map(document.getElementById("google-map"), {
        center: centerCoords,
        zoom: zoom,
        styles: stylesArray,
        disableDefaultUI: true,
        zoomControl: false,
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_TOP
        }
      });
      this.setMarkers();
    });
  }

  setMarkers() {
    window.locationsData.forEach(location => {
      let myLatLng = { lat: +location.lat, lng: +location.lng };

      const { map } = this;
      const marker = new google.maps.Marker({
        position: myLatLng,
        map,
        icon: "http://kamienicepoznanskie.pl/wp-content/uploads/2022/02/pin.png"
      });

      const contentString = `
      <div style='display: flex; flex-direction: column;'>
      <strong style='display: block; margin-bottom: 10px;'>${location.street}</strong>
      <img src="${location.thumbnail}" alt="${location.street}"  height="75" width="75" />
      </div>
      `;

      const InfoWindow = new google.maps.InfoWindow({
        content: contentString
      });

      marker.addListener("click", () => {
        window.location.href = location.link;
      });

      marker.addListener("mouseover", () => {
        InfoWindow.open({
          anchor: marker,
          map,
          shouldFocus: false
        });
      });

      marker.addListener("mouseout", () => {
        InfoWindow.close();
      });
    });
  }
}

if (document.getElementById("google-map")) {
  new handleGoogleMaps();
}
